import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "@pazion/pazion-core/src/services/auth-service";

export async function getProductionWorktypes() {
  return (await getRequest("production-worktypes")).data;
}

export async function getProductionRecords(
  orderId: number,
  params?: { [key: string]: any }
) {
  return (await getRequest(`/catalog/orders/${orderId}/production`, { params }))
    .data;
}

export async function updateProductionLine({
  id,
  data,
}: {
  id: string;
  data: { [key: string]: any };
}) {
  await putRequest(`catalog/production-lines/${id}`, data).data;
}

export async function deleteProductionLine({ id }: { id: string }) {
  await deleteRequest(`catalog/production-lines/${id}`).data;
}


export async function getTaxoptions(): Promise<any[]> {
  return (await getRequest(`catalog/tax`)).data;
}

export async function getProductionOrder(data: any) {
  return (await postRequest("order-production", data)).data;
}

export async function generateProductionsCut(data: Object) {
  return (await postRequest("production-csv", data)).data;
}

export async function changeLineStatus(id: number, data: Object) {
  return (await putRequest(`catalog/production-lines/${id}`, data)).data;
}

export async function generateCutByLine(productionlineId: number) {
  return (
    await getRequest(`catalog/download-productionline-file/${productionlineId}`)
  ).data;
}
